import {create} from 'zustand/react';

import {workspaces, WorkspaceType} from '@workspaces/workspaces';

type Store = {
  workspace: WorkspaceType;
  set: (workspace: WorkspaceType) => void;
};

export const useWorkspace = create<Store>()((set) => ({
  workspace: workspaces[0],
  set: (workspace: WorkspaceType) => set({workspace}),
}));
